import React from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

import Label from 'components/Label'
import Paragraph from 'components/Paragraph'

class Item extends React.Component {
  constructor() {
    super()
    this.input = null
  }

  render() {
    const props = { ...this.props }
    return (
      <Li
        id={`${props.name}-${props.value}`}
        onClick={props.handleSelection.bind(this, props)}
        ref={(c) => {
          this.input = c
        }}
        width={props.width}
        bgColor={backgroundColors.normalLeft}
        height={props.height}>
        <Input
          id={`${props.name}-${props.value}`}
          name={props.name}
          checked={props.selected}
          bgColor={backgroundColors.normalLeft}
          onChange={props.handleSelection.bind(this, props)}
        />
        <Box
          active={props.selected}
          bgColor={backgroundColors.normalLeft}
          className={'box'}
        />
        <TextWrapper>
          <StyledLabel for='f-option'>{props.text}</StyledLabel>
          <StyledLabelSecondary for='f-option'>
            {props.subname ? props.subname : ' '}
          </StyledLabelSecondary>
          <StyledParagraph>{props.description}</StyledParagraph>
        </TextWrapper>
        <CheckMask>
          <CheckWrapper
            bgColor={backgroundColors.normalLeft}
            className={'checkwrapper'}
            active={props.selected}
          />
        </CheckMask>
        <Check className={'check'} bgColor={backgroundColors.normalLeft} />
      </Li>
    )
  }
}

export default class UseType extends React.Component {
  constructor(props) {
    super(props)
    this.handleSelection = this.handleSelection.bind(this)
    this.itemsLoaded = 0
    this.maxHeight = 266
    this.state = {
      itemHeight: this.maxHeight,
    }
  }

  handleSelection(e) {
    if (this.props.onSelectionChange) {
      this.props.onSelectionChange({ ...e })
    }
  }

  render() {
    const { items } = this.props

    return (
      <Container>
        {items &&
          items.map((item, index) => {
            return (
              <Item
                componentLoaded={this.componentLoaded}
                key={`usetype-${item.value}${item.text}`}
                name={this.props.name}
                width={this.props.itemSize}
                handleSelection={this.handleSelection}
                value={item.value}
                text={item.text}
                subname={item.sub_name}
                description={item.description}
                height={`${this.state.itemHeight}px`}
                selected={item.value === this.props.value}
              />
            )
          })}
      </Container>
    )
  }
}

const Container = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 23px;
  padding: 0 10px 3px;

  @media screen and (max-width: 568px) {
    flex-direction: column;
    align-items: center;
  }
`
const Li = styled.li`
  display: block;
  position: relative;

  ${({ width }) => (width ? `max-width: ${width};` : `max-width: 320px;`)}
  ${({ height }) =>
    height ? `min-height: ${height};` : `min-height: 266px;`}
  height: auto;
  margin: 0;

  & + & {
    margin-left: 10px;
  }

  &:hover {
    div.check {
      background: ${({ bgColor }) => bgColor};
      &::before {
        background: #ffffff;
      }
    }
    div.box {
      margin: 2px;

      &:before {
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background-image: ${({ bgColor }) => bgColor};
        z-index: -2;
      }
      &:after {
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: #ffffff;
        z-index: -1;
      }
    }
    div.checkwrapper {
      &:before {
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: ${({ bgColor }) => bgColor};
        z-index: -2;
      }
      &:after {
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: #ffffff;
        z-index: -1;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    margin-right: 0;
    margin-bottom: 30px;
  }

  @media screen and (max-width: 568px) {
    margin-left: 0 !important;
  }
`
const TextWrapper = styled.div`
  position: relative;
  display: block;
  cursor: pointer;
  pointer-events: none;
  margin-bottom: 26px;
  z-index: 4;
`
const Box = styled.div`
  margin: 2px;
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  right: 0;
  bottom: 26px;

  padding: 2px;
  cursor: pointer;

  &:before,
  &:after {
    content: '';
    position: absolute;
  }
  ${({ active, bgColor }) => {
    if (active) {
      return `
        &:before {
          top: -2px;
          left: -2px;
          right: -2px;
          bottom: -2px;
          background-image: ${bgColor};
          z-index: -2;
        }
        &:after {
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: #FFFFFF;
          z-index: -1;
        }
      `
    } else {
      return `
      &:before {
        top: -1px;
        left: -1px;
        right: -1px;
        bottom: -1px;
        background: #DEDEDE;
        z-index: -2;
      }
      &:after {
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: #FFFFFF;
        z-index: -1;
      }
      `
    }
  }}
`
const CheckMask = styled.div`
  display: block;
  position: absolute;
  overflow: hidden;

  width: 56px;
  height: 28px;

  bottom: 26px;
  left: 50%;

  margin-left: -28px;
  z-index: 5;

  cursor: pointer;
`
const CheckWrapper = styled.div`
  z-index: 5;

  display: block;
  position: absolute;
  top: 2px;
  left: 2px;

  cursor: default;

  width: 52px;
  height: 52px;

  &:before,
  &:after {
    content: '';
    position: absolute;

    border-top-left-radius: 100%;
    border-top-right-radius: 100%;
    border-bottom-right-radius: 0%;
    border-bottom-left-radius: 0%;
  }

  ${({ active, bgColor }) => {
    if (active) {
      return `
        &:before {
          top: -2px;
          left: -2px;
          right: -2px;
          bottom: -2px;
          background: ${bgColor};
          z-index: -2;
        }
        &:after {
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: #F9F9F9;
          z-index: -1;
        }
      `
    } else {
      return `
        &:before {
          top: -1px;
          left: -1px;
          right: -1px;
          bottom: -1px;
          background: #DEDEDE;
          z-index: -2;
        }
        &:after {
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background: #F9F9F9;
          z-index: -1;
        }
      `
    }
  }}
`
const Input = styled.input.attrs({
  type: 'radio',
})`
  display: block;
  position: absolute;

  width: 14px;
  height: 14px;
  visibility: hidden;
  z-index: 6;

  &:checked {
    ~ div.check {
      background: ${({ bgColor }) => bgColor};

      &::before {
        background: #ffffff;
      }
    }
    ~ div.box {
      margin: 2px;
      &:before {
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background-image: ${({ bgColor }) => bgColor};
        z-index: -2;
      }
      &:after {
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: #ffffff;
        z-index: -1;
      }
    }
    ~ div.checkwrapper {
      &:before {
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: ${({ bgColor }) => bgColor};
        z-index: -2;
      }
      &:after {
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: #ffffff;
        z-index: -1;
      }
    }
  }
`
const Check = styled.div`
  display: block;
  position: absolute;
  width: 37px;
  height: 37px;
  border: 1px solid #dedede;
  bottom: 5px;
  left: 50%;
  border-radius: 100%;
  margin-left: -19px;
  z-index: 6;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ active, bgColor }) => {
    if (active) {
      return `
        background: ${bgColor};
      `
    } else {
      return `
        background-color: #FFFFFF;
      `
    }
  }}

  &::before {
    display: block;
    content: '';
    border-radius: 100%;
    height: 21px;
    width: 21px;
    background: #ffffff;
  }
`
const StyledLabel = styled(Label)`
  margin: 35px 10px 0px 10px;
  color: #010101;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  text-transform: uppercase;
`
const StyledLabelSecondary = styled(Label)`
  margin: 0px 10px 0px 10px;
  color: #010101;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  text-transform: uppercase;
`
const StyledParagraph = styled(Paragraph)`
  margin: 12px 10px 0px 10px;
  padding-bottom: 40px;
  position: relative;
  color: #010101;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/components/UseType/index.js